import * as React from 'react';
import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import { UIHeading1 } from '@cian/ui-kit/typography';

import { Link } from '../Link/Link';
import { VillageItem, type IVillage } from '../VillageItem/VillageItem';
import * as styles from './Villages.css';
import { Container } from '../Container/Container';

export type { IVillage };

interface IVillagesProps {
  villagesData: IVillage[];
  villagesLink: string;
}

export const Villages: React.FC<IVillagesProps> = ({ villagesData, villagesLink }) => {
  return (
    <Container dataName="Villages">
      <Link href={villagesLink} className={styles['title-container']}>
        <UIHeading1>Каталог коттеджных посёлков</UIHeading1>
        <div className={styles['arrow-icon']}>
          <IconActionChevronRight16 color="superblack_100" />
        </div>
      </Link>
      <div className={styles['villages-list']}>
        {villagesData.map((village, index) => {
          return <VillageItem village={village} key={`village_${index}`} />;
        })}
      </div>
    </Container>
  );
};
